import logo from "../assets/images/mayaLogo.png";
import sideBarBg from "../assets/images/signInImage.png";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
import { useStateContext } from "../context/ContextProvider";
import { useEffect, useState } from "react";
import { FaUser, FaUserTie } from "react-icons/fa";
import { FaUserEdit } from "react-icons/fa";
import { FaMapLocationDot } from "react-icons/fa6";
// import LanguageChanger from "../components/language/LanguageChanger";
import { useTranslation } from "react-i18next";
import { GiHotMeal } from "react-icons/gi";

import { BiLogOut, BiSolidCategory, BiSolidUser, BiSolidVideos } from "react-icons/bi";

import {
  IconButton,
  Avatar,
  Box,
  CloseButton,
  Flex,
  Image,
  HStack,
  Center,
  VStack,
  Icon,
  useColorModeValue,
  Drawer,
  DrawerContent,
  Text,
  useDisclosure,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  useColorMode,
  Divider,

} from "@chakra-ui/react";
import {
  FiHome,
  FiMoon,
  FiSun,
  FiChevronDown,

} from "react-icons/fi";
import { MdDiscount, MdDns, MdLiveTv, MdLocalMovies, MdMovieFilter, MdOutlineSubscriptions } from "react-icons/md";
import { RiImageEditFill, RiMenuFoldLine, RiMenuUnfoldLine, RiMovieFill } from "react-icons/ri";

import { GrChannel, GrUpdate } from "react-icons/gr";
import { BsStars } from "react-icons/bs";
import { IoGameController } from "react-icons/io5";

export default function DefaultLayout() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isSiderBar, setIsSideBar] = useState("block");
  const [changedWidth, setChangedWidth] = useState("280px");
  const { user } = useStateContext();

  const handleCloseSideBar = () => {
    if (isSiderBar === "block") {
      setIsSideBar("none");
      setChangedWidth("full");
    } else {
      setIsSideBar("block");
      setChangedWidth("280px");
    }
  };

  return (
    <Box minH="100vh" bg={useColorModeValue("gray.50", "gray.900")}>
      <SidebarContent
        onClose={() => onClose}
        display={{ base: "none", md: isSiderBar }}
      />

      <Drawer
        autoFocus={false}
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        returnFocusOnClose={false}
        onOverlayClick={onClose}
        size="full"
      >
        <DrawerContent>
          <SidebarContent onClose={onClose} />
        </DrawerContent>
      </Drawer>
      {/* mobilenav */}

      <MobileNav
        onOpen={onOpen}
        handleCloseSideBar={handleCloseSideBar}
        isSiderBar={isSiderBar}
      />

      <Box ml={{ base: 0, md: changedWidth }} p={6}>
        <Outlet />
      </Box>

    </Box>
  );
}

const SidebarContent = ({ onClose, ...rest }) => {
  const { user, setToken, setUser } = useStateContext();
 
  const userRole = user.role;
  const { t } = useTranslation();

  const LinkItems = {
    SUPERADMIN: [
      { name: t("Tableau de bord"), icon: FiHome, path: "/" },
      { name: t("Gestion Admins"), icon: FaUserTie, path: "/admins" },
      { name: t("Gestion Utilisateurs"), icon: FaUser, path: "/users" },
      { name: t("Gestion abonnements"), icon: MdOutlineSubscriptions , path: "/subscription" },
      { name: t("Gestion codes promo"), icon: MdDiscount , path: "/codes-promo" },
      { name: t("Gestion Catégories"), icon: BiSolidCategory, path: "/categories" },
      { name: t("Gestion Pays"), icon: FaMapLocationDot, path: "/pays" },
      // { name: t("Gestion contenu"), icon: MdLiveTv , path: "/contents" },
      { name: t("Gestion films"), icon: RiMovieFill , path: "/films" },
      { name: t("Gestion séries"), icon: BiSolidVideos , path: "/series" },
      { name: t("Contenu en highlight"), icon: BsStars , path: "/highlight" },
      { name: t("Nouveautés"), icon: MdMovieFilter    , path: "/new_contents" },
      { name: t("Gestion des jeux"), icon: IoGameController    , path: "/jeux" },
      { name: t("Éditeur Maya+"), icon: RiImageEditFill , path: "/editor" },
      // { name: t("Mises à jour"), icon: GrUpdate , path: "/updates" },

    ],
    ADMIN: [
      { name: t("Tableau de bord"), icon: FiHome, path: "/" },
      // { name: t("Gestion Admins"), icon: FaUserTie, path: "/admins" },
      { name: t("Gestion Utilisateurs"), icon: FaUser, path: "/users" },
      // { name: t("Gestion abonnements"), icon: MdOutlineSubscriptions , path: "/subscription" },
      { name: t("Gestion Catégories"), icon: BiSolidCategory, path: "/categories" },
      // { name: t("Gestion contenu"), icon: MdLiveTv , path: "/contents" },
      { name: t("Gestion Pays"), icon: FaMapLocationDot, path: "/pays" },

      { name: t("Gestion films"), icon: RiMovieFill , path: "/films" },
      { name: t("Gestion séries"), icon: BiSolidVideos , path: "/series" },
      
      { name: t("Contenu en highlight"), icon: BsStars , path: "/highlight" },
      { name: t("Nouveautés"), icon: MdMovieFilter    , path: "/new_contents" },
      { name: t("Gestion des jeux"), icon: IoGameController    , path: "/jeux" },
      { name: t("Éditeur Maya+"), icon: RiImageEditFill , path: "/editor" },

    ],
  };

  const items = LinkItems[userRole] || [];
  // const items = [
  //   { name: t("Tableau de bord"), icon: FiHome, path: "/" },
  //   { name: t("Gestion Admins"), icon: FaUserTie, path: "/admins" },
  //   { name: t("Gestion Utilisateurs"), icon: FaUser, path: "/users" },
  //   { name: t("Gestion pays"), icon: FaMapLocationDot, path: "/pays" },
  //   { name: t("Gestion DNS"), icon: MdDns, path: "/dns" },
  //   { name: t("Gestion chaines"), icon: GrChannel, path: "/Channels" },
  //   { name: t("Gestion repas"), icon: GiHotMeal, path: "/repas" },
  // ]

  const onLogout = (ev) => {
    ev.preventDefault();
    setUser({});
    setToken(null);
    localStorage.removeItem("tokenExpirationTime");
    localStorage.removeItem("refreshTimeAdmin");
    localStorage.removeItem("role");

  };
  return (
    <Box
      transition="3s ease"
      color="white"
      w={{ base: "full", md: "270px" }}
      pos="fixed"

      h="full"

      {...rest}
    >
      <Box
        w={"100%"} h={"100%"} position="relative"
        // bgGradient={useColorModeValue("linear(to-b,gray.600, gray.800, gray.900)", "linear(to-b, gray.700, gray.800, gray.900)")}
        bgImage={sideBarBg}
        >
        <Flex flexDirection={"column"} pt={2} h="20%" alignItems="center" mx="8" justifyContent="center">

          <CloseButton display={{ base: "flex", md: "none" }} onClick={onClose} position={"absolute"} top={2} right={2} />

          <Image  src={logo} width="100px"  ></Image>

        </Flex>
        <Flex py={1} alignItems={'center'} flexDirection={"column"}>
          <Divider />
        </Flex>
        <Box overflowY={"scroll"} py={0} my={0} h={'68%'}
          css={{
            /* Hide scrollbar */
            "&::-webkit-scrollbar": {
              display: "none",
            },
            /* Optional: Firefox scrollbar */
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          {items.map((link, key) => (
            <NavItem
              items={items}
              key={link.name}
              icon={link.icon}
              onClose={onClose}
            >
              {link.name}
            </NavItem>
          ))}
        </Box>

        <Flex py={2} alignItems={'center'} flexDirection={"column"}>
          <Divider borderColor='gray.300' />

        </Flex>
        <Flex
          justify={"center"}
          align="center"
          mt={1}
          color={"red.200"}
          cursor="pointer"
          gap={2}
          onClick={onLogout}
        >
          <BiLogOut size={20} />
          <Text fontSize="md">{t("Déconnexion")}</Text>


        </Flex>
      </Box>
    </Box>
  );
};

const NavItem = ({ icon, children, items, onClose, ...rest }) => {
  
  const navigate = useNavigate();
  const location = useLocation();
  const pathLink = items.find((e) => e.name === children);

  const handleClick = () => {

    navigate(pathLink.path);
    onClose();
  };


  return (

    <Box
      onClick={handleClick}
      style={{ textDecoration: "none" }}
      _focus={{ boxShadow: "none" }}
    >
      <Flex
        align={"center"}
        mx="4"
        p="4"
        my={2}
        rounded={"lg"}
        boxShadow={pathLink.path === location.pathname ? "6px 8px 10px 0px #ffffff2b" : ""}
        fontWeight={pathLink.path === location.pathname ? "semibold" : ""}


        role="group"
        cursor="pointer"

        {...rest}
      >
        {icon && (
          <Icon
            bg={pathLink.path === location.pathname ? "rgb(255 255 255 / 27%)" : ""}
            p={pathLink.path === location.pathname ? 1.5 : 0}
            rounded={pathLink.path === location.pathname ? "md" : ""}
            mr="4"
            fontSize={pathLink.path === location.pathname ? "30" : "18"}
            as={icon}
          />
        )}

        <Text fontSize={pathLink.path === location.pathname ? "md" : "sm"}>{children}</Text>

      </Flex>
    </Box>
  );
};

const MobileNav = ({ onOpen, handleCloseSideBar, isSiderBar, ...rest }) => {
  const { user,setToken, setUser } = useStateContext();
  
  const { colorMode, toggleColorMode } = useColorMode();
  const { t } = useTranslation()

  // Logout Function
  const navigate = useNavigate();

  const onLogout = (ev) => {
    ev.preventDefault();
    setUser({});
    setToken(null);
    localStorage.removeItem("tokenExpirationTime");
    localStorage.removeItem("refreshTimeAdmin");
    localStorage.removeItem("role");

  };
  const [changeBgNavBar, setChangeBgNavBar] = useState('white')



  useEffect(() => {
    const onPageScroll = () => {
      if (window.pageYOffset > 50) {
        setChangeBgNavBar("#ffffff42");
      } else {
        setChangeBgNavBar("white");
      }
    };
    window.addEventListener("scroll", onPageScroll);

    return () => {
      window.removeEventListener("scroll", onPageScroll);
    };
  }, []);



  const colorCondition = useColorModeValue("black", changeBgNavBar === "white" ? "black" : "white")

  const flexContent = (
    <>

      <HStack w={{ base: "90%", sm: "80%", md: '50%' }} justify={"space-between"} shadow={"lg"} rounded={"lg"} px={5}
        background={changeBgNavBar}
        backdropFilter={"auto"}
        backdropBlur={'8px'}
        position={'fixed'}
        zIndex={999}
        spacing={{ base: "0", md: "5" }}>

        <Flex align={'center'} gap={5}>

          {isSiderBar === "block" ? (
            <IconButton
              display={{ base: "none", md: "flex" }}
              icon={<RiMenuFoldLine color={colorCondition} />}
              onClick={handleCloseSideBar}
              borderColor={'gray.200'}
              border={"none"}
              variant="outline"

            />
          ) : (
            <IconButton
              display={{ base: "none", md: "flex" }}
              onClick={handleCloseSideBar}
              icon={<RiMenuUnfoldLine color={colorCondition} />}
              borderColor={'gray.200'}
              border={"none"}
              variant="outline"

              aria-label="open menu"

            />
          )}
          <Text
            display={{ base: 'none', md: "block" }}
            color={"black"}

            fontWeight={"semi-bold"}
            fontSize={{ base: "md", sm: "md", md: "lg" }}
          >
            Maya+ administrative
          </Text>

        </Flex>



        <Flex align={'center'} gap={5}>


          <IconButton
            display={{ base: "flex", md: "none" }}
            onClick={onOpen}
            icon={<RiMenuFoldLine color={colorCondition} />}
            borderColor={'gray.200'}
            border={"none"}
            variant="outline"

            aria-label="open menu"

          />

          <Flex pr={{ base: 3, md: 0 }}>
        
            {colorMode === "light" ? <FiMoon
              fontSize={"19px"}
              color="black"
              cursor={'pointer'}
              onClick={toggleColorMode} /> :
              <FiSun
                fontSize={"19px"}
                color="#D69E2E"
                cursor={'pointer'}
                onClick={toggleColorMode} />}
          </Flex>

          <Flex px={3} alignItems={"center"}>
            <Menu >
              <MenuButton
                py={4}
                transition="all 0.3s"
                _focus={{ boxShadow: "none" }}
              >
                <HStack>
                  <Avatar size={"sm"} src={user.image} />
                  <VStack
                    display={{ base: "none", lg: "flex" }}
                    alignItems="flex-start"
                    spacing="1px"
                    ml="2"
                  >
                    <Text fontSize="sm" color={colorCondition}>
                      {user.first_name} {user.last_name} 
                    </Text>
                    <Text fontSize="xs" color="orange.400">
                      {(user.role === "SUPERADMIN")
                        ? t("super-admin")
                        : (user.role === "ADMIN")
                          ? t("Admin")

                          : ""}
                    </Text>
                  </VStack>
                  <Box display={{ base: "none", md: "flex" }} color={colorCondition}>
                    <FiChevronDown />
                  </Box>
                </HStack>
              </MenuButton>
              <MenuList
                color={useColorModeValue("black", "white")}
                zIndex={9999}
                borderColor={useColorModeValue("gray.100", "gray.700")}
                alignItems={"center"}
                bg={useColorModeValue("gray.100", "gray.700")}
                boxShadow={"xl"}
              >
                <Center mt={3} mb={3}>
                  <Avatar size={"xl"} src={user.image} />
                </Center>

                <MenuItem
                  fontSize={'sm'}
                  icon={<BiSolidUser size={15} />}
                  bg={useColorModeValue("gray.100", "gray.700")}
                  onClick={() => navigate("/profil")}
                >
                  {" "}
                  {t("Profil")}
                </MenuItem>
                <MenuItem
                  fontSize={'sm'}
                  icon={<FaUserEdit size={15} />}
                  // _hover={{ bg: "gray.200" }}
                  bg={useColorModeValue("gray.100", "gray.700")}
                  onClick={() => navigate("/modifier-profil")}
                >
                  {" "}
                  {t("Mes paramètres")}
                </MenuItem>

                <MenuDivider borderColor={'gray.300'} />
                <MenuItem
                  icon={<BiLogOut size={20} />}
                  // _hover={{ bg: "gray.200" }}
                  bg={useColorModeValue("gray.100", "gray.700")}
                  onClick={onLogout}
                  color={'red.400'}
                >
                  {t("Déconnexion")}
                </MenuItem>
              </MenuList>
            </Menu>
          </Flex>
        </Flex>

      </HStack>
    </>
  );
  const b = useColorModeValue("linear(to-r, black, gray.700)", "linear(to-l, black, black)");
  const border = useColorModeValue("black", "gray.700");
  return (
    <Box>
      {isSiderBar === "block" ? (
        <Flex
          pt={5}
          ml={{ base: 0, md: "full" }}
          px={{ base: 4, md: 4 }}
          height="20"
          alignItems="center"
          color="white"
          marginLeft={{ base: 0, md: 60, lg: 60 }}
          bgGradient={"transparent"}
         
          justifyContent={"end"}
          position={'relative'}
          {...rest}
        >
          {flexContent}
        </Flex>
      ) : (
        <Flex
          pt={5}
          ml={{ base: 0, md: "full" }}
          px={{ base: 4, md: 4 }}
          height="20"
          alignItems="center"
          color="black"
          marginLeft={0}
          bgGradient={"transparent"}
        
          justifyContent={"end"}
          {...rest}
        >
          {flexContent}
        </Flex>
      )}

    </Box>
  );
};






